export function formatValorReal(valor: any): string {
  if (valor == null || valor === "") return "—";

  let numero: number;

  if (typeof valor === "string") {
    // Remove espaços
    valor = valor.trim();

    // Se houver vírgula, considera como decimal
    if (valor.includes(",")) {
      // Remove pontos de milhar
      valor = valor.replace(/\./g, "").replace(",", ".");
    }
    // Caso não haja vírgula, deixa o ponto decimal como está
    numero = parseFloat(valor);
  } else {
    numero = Number(valor);
  }

  if (isNaN(numero)) return "—";

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numero);
}

// Formatadores e parsers de moeda BRL para campos de formulário

export const formatBRLCurrency = (
  value: string | number | undefined | null
) => {
  if (value === undefined || value === null) return "";
  return `R$ ${Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const parseBRLCurrency = (value: string | undefined | null) => {
  if (!value) return "";
  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
  return isNaN(Number(parsedValue)) ? "" : parsedValue;
};
